import { EDeliverableStatus } from '@constants';
import styled, { css } from 'styled-components';

import { EIconType } from '@/components/Icon';
import { getIconColor } from '@/utils/fileIcon';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  @media (max-width: ${({ theme }) => theme.mediaQueries.sm}) {
    align-items: flex-start;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.black1};
  }

  cursor: pointer;
`;

export const DeliverableInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const DeliverableName = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const DeliverableCourse = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const NoteWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  flex-shrink: 0;
  @media (max-width: ${({ theme }) => theme.mediaQueries.sm}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const NoteText = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-align: right;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const StatusText = styled.span<{ $status: EDeliverableStatus; $note?: number }>`
  display: flex;
  padding: 1px 8px;
  align-items: center;
  gap: 6px;
  border-radius: 4px;
  white-space: nowrap;
  ${({ $status }) => {
    if ($status === EDeliverableStatus.COMPLETED) {
      return css`
        color: ${({ theme }) => theme.colors.green7};
        border: 1px solid ${({ theme }) => theme.colors.green4};
        background: ${({ theme }) => theme.colors.green2};
      `;
    }

    return css`
      border-radius: 4px;
      border: 1px solid ${({ theme }) => theme.colors.orange4};
      color: ${({ theme }) => theme.colors.orange7};
    `;
  }}
`;

export const ScoreText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black6};
`;
export const IconWrapper = styled.span<{ iconName?: EIconType }>`
  display: flex;
  padding: 9px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  max-width: 32px;
  background: ${({ theme, iconName }) => getIconColor(theme, iconName as EIconType)};
`;
